import { useState, useCallback, useEffect } from "react"
import { debounce } from "lodash"

const useDebounce = (delay, defaultValue = "") => {
  const [deferredValue, setDeferredValue] = useState(defaultValue)
  const [value, setValue] = useState(defaultValue)

  const setDeferredValueDebounced = useCallback(
    debounce(setDeferredValue, delay),
    []
  )

  useEffect(() => {
    setDeferredValueDebounced(value)
  }, [value])

  return {
    setValue,
    value,
    deferredValue,
  }
}

export default useDebounce
